import type { ReactNode } from "react";
import { Reveal } from "./Reveal";

export function SectionHeader({
  eyebrow,
  title,
  description,
  align = "left",
  index,
}: {
  eyebrow?: string;
  title: ReactNode;
  description?: ReactNode;
  align?: "left" | "center";
  index?: string;
}) {
  return (
    <div className={`flex flex-col gap-4 ${align === "center" ? "items-center text-center mx-auto max-w-3xl" : ""}`}>
      <Reveal className="flex items-center gap-3">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        {index && <span className="font-mono text-[10px] text-ink-soft tracking-widest">{index}</span>}
      </Reveal>
      <Reveal delay={0.05} as="h2" className="text-balance text-3xl md:text-5xl font-semibold tracking-tight leading-[1.05]">
        {title}
      </Reveal>
      {description && (
        <Reveal delay={0.1} as="p" className={`text-pretty text-base md:text-lg text-ink-soft leading-relaxed ${align === "left" ? "max-w-2xl" : ""}`}>
          {description}
        </Reveal>
      )}
    </div>
  );
}
